angular.module('unica.basic_controller', [])

.controller('BasicController', function(
	$rootScope, $scope, $state, $stateParams, $interval, $timeout,
	$http, getBaseApiURL,
	$transitions, toast, $uibModal,
	AuthService, LogoutService,
	CONFIG, AUTH_EVENTS, PERMISSIONS, APPROVATION_LIST_STATUS,
	UserListService,
	EventListService,
	EventFieldListService,
	EventTagListService,
	AgendaService,
	ApprovationListListService,
	InvitationListListService,
	InvitationListService,
	MaterialListService,
	MediaDirectoryListService,
	FeedbackCategoryListService,
	WikiListService,
	PartnerListService,
	RelatorListService,
	WorkshopListService,
	WorkshopSessionListService,
	TrackListService,
	HotelListService,
	RoomListService,
	InvitationRoomListService,
	TransferListService,
	SurveyListService,
	InvitationTransferListService,
	EVENT_TYPES, TASK_TYPES, DOC_REGISTRATION_TYPES, ROOM_OCCUPATIONS,
	ACC_RELATIONSHIPS,
	USER_CATEGORIES, USER_ROLES, USER_SUB_ROLES,
	getCountries, TRANSFER_TYPES, USER_FIELDS
) {

	$rootScope.str_random = function( length )
	{
		var text     = '',
			i        = 0,
			possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (; i < length; i++) {
			text += possible.charAt(Math.floor(Math.random() * possible.length));
		}

		return text;
	}

	// ============================= //
	//
	// UI COMPONENTS STUFF
	//
	// ============================= //

	$rootScope.appVersion = CONFIG.version;
	$rootScope.loaderVisible = false;
	$rootScope.showLoader = function() {
		$rootScope.loaderVisible = true;
	};
	$rootScope.hideLoader = function() {
		$rootScope.loaderVisible = false;
	};

	$rootScope.datepickerOptions = {
		showWeeks: false,
		startingDay: 1,
		format: 'dd/MM/yyyy',
		showButtonBar: false
	};

	$scope.datepickers = {
		dob: false,
		doc_emission_date: false,
		doc_expiration_date: false
	};

	$scope.openDatepicker = function(index) {
		$scope.datepickers[index] = !$scope.datepickers[index];
	};

	$rootScope.tinymceOptions = {
		inline: false,
		base_url: '/js/app/vendor',
		theme_url: '/js/app/vendor/tinymce/themes/modern/theme.js',
		skin_url:  '/js/app/vendor/tinymce/skins/lightgray/',
		branding: false,
		menubar: false,
		statusbar: false,
		convert_urls: true,
		relative_urls: false,
		remove_script_host: false,
		height : 150,
		plugins: ['paste', 'code', 'link'],
		toolbar1: 'undo redo | bold italic underline | link',
	};

	$rootScope.tinymceOptionsPlus = {
		inline: false,
		base_url: '/js/app/vendor',
		theme_url: '/js/app/vendor/tinymce/themes/modern/theme.js',
		skin_url:  '/js/app/vendor/tinymce/skins/lightgray/',
		branding: false,
		menubar: false,
		statusbar: false,
		convert_urls: true,
		relative_urls: false,
		remove_script_host: false,
		height : 150,
		plugins: ['paste', 'code', 'link', 'textcolor', 'lists'],
		toolbar: [
			'undo redo | bold italic underline strikethrough | code paste | forecolor | link unlink',
			'alignleft aligncenter alignright alignjustify | numlist bullist | fontselect fontsizeselect'
		],
		textcolor_map: [
			"C21B17", "Rosso Generali",
			"222bd4", "Blu"
		],
	};

	$rootScope.tinymceOptionsEmailSubject = {
		inline: false,
		base_url: '/js/app/vendor',
		theme_url: '/js/app/vendor/tinymce/themes/modern/theme.js',
		skin_url:  '/js/app/vendor/tinymce/skins/lightgray/',
		branding: false,
		menubar: false,
		statusbar: false,
		height : 50,
		plugins: ['paste', 'code'],
		toolbar1: 'undo redo | placeholder_btn',
		setup: function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: [
					{ text: 'Nome', value: '{FIRST_NAME}' },
					{ text: 'Cognome', value: '{LAST_NAME}' },
					{ text: 'Data Tappa Da', value: '{FIRST_STAGE_DAY_FROM}' },
					{ text: 'Data Tappa A', value: '{FIRST_STAGE_DAY_TO}' },
					{ text: 'Orario Tappa Da', value: '{FIRST_STAGE_TIME_FROM}' },
					{ text: 'Orario Tappa A', value: '{FIRST_STAGE_TIME_TO}' },
					{ text: 'Nome Location', value: '{LOCATION_NAME}' },
					{ text: 'Indirizzo Location', value: '{LOCATION_ADDRESS}' },
					{ text: 'Nome Agenzia', value: '{AGENCY_NAME}' },
				],
				onPostRender: function () {
				}
			});
		}
	};


	$rootScope.tinymceOptionsEmailBody = {
		inline: false,
		base_url: '/js/app/vendor',
		theme_url: '/js/app/vendor/tinymce/themes/modern/theme.js',
		skin_url:  '/js/app/vendor/tinymce/skins/lightgray/',
		branding: false,
		menubar: false,
		statusbar: false,
		convert_urls: true,
		relative_urls: false,
		remove_script_host: false,
		height : 150,
		plugins: ['paste', 'code', 'link', 'textcolor', 'lists'],
		toolbar: [
			'undo redo | bold italic underline strikethrough | code paste | forecolor | link unlink',
			'alignleft aligncenter alignright alignjustify | numlist bullist | fontselect fontsizeselect',
			'placeholder_btn | sections_btn',
		],
		textcolor_map: [
			"C21B17", "Rosso Generali",
			"222bd4", "Blu"
		],
		setup: function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: [
					{ text: 'Nome', value: '{FIRST_NAME}' },
					{ text: 'Cognome', value: '{LAST_NAME}' },
					{ text: 'Data Tappa Da', value: '{FIRST_STAGE_DAY_FROM}' },
					{ text: 'Data Tappa A', value: '{FIRST_STAGE_DAY_TO}' },
					{ text: 'Orario Tappa Da', value: '{FIRST_STAGE_TIME_FROM}' },
					{ text: 'Orario Tappa A', value: '{FIRST_STAGE_TIME_TO}' },
					{ text: 'Nome Location', value: '{LOCATION_NAME}' },
					{ text: 'Indirizzo Location', value: '{LOCATION_ADDRESS}' },
					{ text: 'Nome Agenzia', value: '{AGENCY_NAME}' },
				],
				onPostRender: function () {
				}
			});
		}
	};

	// TINYMCE COMUNICATION APPROVATION LIST

	$rootScope.tinymceOptionsEmailSubjectApprovationList = {
		inline: false,
		base_url: '/js/app/vendor',
		theme_url: '/js/app/vendor/tinymce/themes/modern/theme.js',
		skin_url:  '/js/app/vendor/tinymce/skins/lightgray/',
		branding: false,
		menubar: false,
		statusbar: false,
		height : 50,
		plugins: ['paste', 'code'],
		toolbar1: 'undo redo | placeholder_btn',
		setup: function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: [
					{ text: 'Nome ZM',       value: '{ZM_FIRST_NAME}' },
					{ text: 'Cognome ZM',    value: '{ZM_LAST_NAME}' },
					{ text: 'Titolo Evento', value: '{EVENT_TITLE}' },
					{ text: 'Data Tappa Da', value: '{FIRST_STAGE_DAY_FROM}' },
					{ text: 'Data Tappa A',  value: '{FIRST_STAGE_DAY_TO}' },
					{ text: 'Orario Tappa Da', value: '{FIRST_STAGE_TIME_FROM}' },
					{ text: 'Orario Tappa A',  value: '{FIRST_STAGE_TIME_TO}' },
					{ text: 'Numero Posti',  value: '{APPROVATION_LIST_SEATS}' },
					{ text: 'Data Scadenza Approvazione ZM', value: '{APPROVATION_LIST_ZM_EXPIRATION_DATE}' },
					{ text: 'Ora Scadenza Approvazione ZM',  value: '{APPROVATION_LIST_ZM_EXPIRATION_TIME}' },
					{ text: 'Status',        value: '{STATUS}' },
					{ text: 'Nome Location', value: '{LOCATION_NAME}' },
					{ text: 'Indirizzo Location', value: '{LOCATION_ADDRESS}' },
				],
				onPostRender: function () {
				}
			});
		}
	};

	$rootScope.tinymceOptionsEmailBodyApprovationList = {
		inline: false,
		base_url: '/js/app/vendor',
		theme_url: '/js/app/vendor/tinymce/themes/modern/theme.js',
		skin_url:  '/js/app/vendor/tinymce/skins/lightgray/',
		branding: false,
		menubar: false,
		statusbar: false,
		convert_urls: true,
		relative_urls: false,
		remove_script_host: false,
		height : 150,
		plugins: ['paste', 'code', 'link', 'textcolor', 'lists'],
		toolbar: [
			'undo redo | bold italic underline strikethrough | code paste | forecolor | link unlink',
			'alignleft aligncenter alignright alignjustify | numlist bullist | fontselect fontsizeselect | placeholder_btn'
		],
		textcolor_map: [
			"C21B17", "Rosso Generali",
			"222bd4", "Blu"
		],
		setup: function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: [
					{ text: 'Nome ZM',            value: '{ZM_FIRST_NAME}' },
					{ text: 'Cognome ZM',         value: '{ZM_LAST_NAME}' },
					{ text: 'Titolo Evento',      value: '{EVENT_TITLE}' },
					{ text: 'Nome Location',      value: '{LOCATION_NAME}' },
					{ text: 'Indirizzo Location', value: '{LOCATION_ADDRESS}' },
					{ text: 'Data Tappa Da',      value: '{FIRST_STAGE_DAY_FROM}' },
					{ text: 'Data Tappa A',       value: '{FIRST_STAGE_DAY_TO}' },
					{ text: 'Orario Tappa Da',    value: '{FIRST_STAGE_TIME_FROM}' },
					{ text: 'Orario Tappa A',     value: '{FIRST_STAGE_TIME_TO}' },
					{ text: 'Numero Posti',       value: '{APPROVATION_LIST_SEATS}' },
					{ text: 'Status',             value: '{STATUS}' },
					{ text: 'Data Scadenza Approvazione ZM', value: '{APPROVATION_LIST_ZM_EXPIRATION_DATE}' },
					{ text: 'Ora Scadenza Approvazione ZM',  value: '{APPROVATION_LIST_ZM_EXPIRATION_TIME}' },
				],
				onPostRender: function () {
				}
			});
		}
	};


	// TINYMCE COMUNICATION GRAND PRIX

	$rootScope.tinymceOptionsEmailSubjectGrandPrix = {
		inline: false,
		base_url: '/js/app/vendor',
		theme_url: '/js/app/vendor/tinymce/themes/modern/theme.js',
		skin_url:  '/js/app/vendor/tinymce/skins/lightgray/',
		branding: false,
		menubar: false,
		statusbar: false,
		height : 50,
		plugins: ['paste', 'code'],
		toolbar1: 'undo redo | placeholder_btn',
		setup: function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: [
					{ text: 'Nome ZM',       value: '{ZM_FIRST_NAME}' },
					{ text: 'Cognome ZM',    value: '{ZM_LAST_NAME}' },
					{ text: 'Titolo Evento', value: '{EVENT_TITLE}' },
					{ text: 'Data Tappa Da', value: '{FIRST_STAGE_DAY_FROM}' },
					{ text: 'Data Tappa A',  value: '{FIRST_STAGE_DAY_TO}' },
					{ text: 'Orario Tappa Da', value: '{FIRST_STAGE_TIME_FROM}' },
					{ text: 'Orario Tappa A',  value: '{FIRST_STAGE_TIME_TO}' },
					{ text: 'Nome Location', value: '{LOCATION_NAME}' },
					{ text: 'Indirizzo Location', value: '{LOCATION_ADDRESS}' },
				],
				onPostRender: function () {
				}
			});
		}
	};

	$rootScope.tinymceOptionsEmailBodyGrandPrix = {
		inline: false,
		base_url: '/js/app/vendor',
		theme_url: '/js/app/vendor/tinymce/themes/modern/theme.js',
		skin_url:  '/js/app/vendor/tinymce/skins/lightgray/',
		branding: false,
		menubar: false,
		statusbar: false,
		convert_urls: true,
		relative_urls: false,
		remove_script_host: false,
		height : 150,
		plugins: ['paste', 'code', 'link', 'textcolor', 'lists'],
		toolbar: [
			'undo redo | bold italic underline strikethrough | code paste | forecolor | link unlink',
			'alignleft aligncenter alignright alignjustify | numlist bullist | fontselect fontsizeselect | placeholder_btn'
		],
		textcolor_map: [
			"C21B17", "Rosso Generali",
			"222bd4", "Blu"
		],
		setup: function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: [
					{ text: 'Nome ZM',            value: '{ZM_FIRST_NAME}' },
					{ text: 'Cognome ZM',         value: '{ZM_LAST_NAME}' },
					{ text: 'Titolo Evento',      value: '{EVENT_TITLE}' },
					{ text: 'Nome Location',      value: '{LOCATION_NAME}' },
					{ text: 'Indirizzo Location', value: '{LOCATION_ADDRESS}' },
					{ text: 'Data Tappa Da',      value: '{FIRST_STAGE_DAY_FROM}' },
					{ text: 'Data Tappa A',       value: '{FIRST_STAGE_DAY_TO}' },
					{ text: 'Orario Tappa Da',    value: '{FIRST_STAGE_TIME_FROM}' },
					{ text: 'Orario Tappa A',     value: '{FIRST_STAGE_TIME_TO}' },
				],
				onPostRender: function () {
				}
			});
		}
	};

	$rootScope.tinymceOptionsEmailSubjectGrandPrixBasic = {
		inline: false,
		base_url: '/js/app/vendor',
		theme_url: '/js/app/vendor/tinymce/themes/modern/theme.js',
		skin_url:  '/js/app/vendor/tinymce/skins/lightgray/',
		branding: false,
		menubar: false,
		statusbar: false,
		height : 50,
		plugins: ['paste', 'code'],
		toolbar1: 'undo redo | placeholder_btn',
		setup: function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: [
					{ text: 'Nome ZM',       value: '{ZM_FIRST_NAME}' },
					{ text: 'Cognome ZM',    value: '{ZM_LAST_NAME}' },
					{ text: 'Nome Agenzia',  value: '{AGENCY_NAME}' },
					{ text: 'Titolo Evento', value: '{EVENT_TITLE}' },
				],
				onPostRender: function () {
				}
			});
		}
	};

	$rootScope.tinymceOptionsEmailBodyGrandPrixBasic = {
		inline: false,
		base_url: '/js/app/vendor',
		theme_url: '/js/app/vendor/tinymce/themes/modern/theme.js',
		skin_url:  '/js/app/vendor/tinymce/skins/lightgray/',
		branding: false,
		menubar: false,
		statusbar: false,
		convert_urls: true,
		relative_urls: false,
		remove_script_host: false,
		height : 150,
		plugins: ['paste', 'code', 'link', 'textcolor', 'lists'],
		toolbar: [
			'undo redo | bold italic underline strikethrough | code paste | forecolor | link unlink',
			'alignleft aligncenter alignright alignjustify | numlist bullist | fontselect fontsizeselect | placeholder_btn'
		],
		textcolor_map: [
			"C21B17", "Rosso Generali",
			"222bd4", "Blu"
		],
		setup: function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: [
					{ text: 'Nome ZM',            value: '{ZM_FIRST_NAME}' },
					{ text: 'Cognome ZM',         value: '{ZM_LAST_NAME}' },
					{ text: 'Nome Agenzia',       value: '{AGENCY_NAME}' },
					{ text: 'Titolo Evento',      value: '{EVENT_TITLE}' },
				],
				onPostRender: function () {
				}
			});
		}
	};



	$rootScope.tinymceOptionsComplex = {
		inline: false,
		// skin: 'lightgray',
		// theme : 'modern',
		base_url: '/js/app/vendor',
		theme_url: '/js/app/vendor/tinymce/themes/modern/theme.js',
		skin_url:  '/js/app/vendor/tinymce/skins/lightgray/',
		branding: false,
		menubar: false,
		statusbar: false,
		convert_urls: true,
		relative_urls: false,
		remove_script_host: false,
		height : 150,
		plugins: ['paste', 'code', 'link', 'textcolor', 'lists'],
		toolbar: [
			'styleselect | alignleft aligncenter alignright alignjustify | forecolor | outdent indent',
			'undo redo | bold italic underline strikethrough | numlist bullist | fontselect fontsizeselect | link unlink | paste code'
		],
		textcolor_map: [
			"C21B17", "Rosso Generali",
			"222bd4", "Blu"
		]
	};
	// console.log('controllers basic');


	$rootScope.menuOpen = false;
	$rootScope.toggleMenu = function() {
		$rootScope.menuOpen = !$rootScope.menuOpen;
	};


	// ============================= //
	//
	//  ERRORS MANAGEMENT
	//
	// ============================= //

	$rootScope.debug = ( appEnv == 'local' ? true : false );

	$rootScope.showSuccessMsg = function(title, message) {
		if ( !message ) {
			message = '';
		}

		toast({
			maxToast: 3,
			duration  : 10000,
			message   : '<strong>' + title + '</strong>' + message,
			position: 'center',
			container: '.alert_container',
			className : 'alert-success',
			insertFromTop: true
		});
	};

	$rootScope.showAlertMsg = function(message, type) {
		toast({
			maxToast: 3,
			duration  : 10000,
			message   : '<strong>' + message + '</strong>',
			position: 'center',
			container: '.alert_container',
			className : 'alert-' + type,
			dismissible: (type == 'error' ? true : false),
			insertFromTop: true
		});
	};

	$rootScope.hideAlertMessage = function() {
		$rootScope.alert.class = 'hide';
	};

	$rootScope.showErrorMsg = function(message) {
		if ( !message ) {
			message = 'Si è verificato un\'errore';
		}
		$rootScope.showAlertMsg(message, 'danger');
	};

	$rootScope.showWarningMsg = function(message) {
		if ( !message ) {
			message = 'Presta attenzione all\'operazione in corso';
		}
		$rootScope.showAlertMsg(message, 'warning');
	};

	$rootScope.showNeutralMsg = function(message) {
		$rootScope.showAlertMsg(message, 'info');
	};

	$rootScope.manageError = function(data) {
		$scope.hideLoader();

		angular.forEach(data.errors, function(item) {
			$timeout(function() {
				$scope.showErrorMsg( item[0] );
			}, 10);
		});
	};







	// ============================= //
	//
	//  USER AUTH SECTION
	//
	// ============================= //

	$rootScope.isAdmin         = false;
	$rootScope.isService       = false;
	$rootScope.isReportManager = false;
	$rootScope.isAM            = false;
	$rootScope.isZM            = false;

	var userRedirect = function(from) {
		console.log('User redirect triggered from: ' + from);
		if ($state.current.name === 'app.auth_login') {
			return;
		}
		console.log('Redirecting to login page...');
		$rootScope.setCurrentUser( null );

		localStorage.clear();
		$rootScope.isAuthorized = false;
		window.location.href = '/nam/login';
		//$state.go('app.auth_login');
	};

	$rootScope.isAuthorized = false;
	$rootScope.authResolved = false;

	// AuthService.isAuthenticated().then(function(isAuth) {
	//
	// 	if (isAuth) {
	//
	// 		$http({
	// 			method: 'GET',
	// 			url: getBaseApiURL + '/auth/me',
	// 			withCredentials: true
	// 		}).then(function(response) {
	//
	// 			if (response.data) {
	// 				$rootScope.setCurrentUser(response.data);
	// 				$rootScope.isAuthorized = true;
	// 			}
	//
	// 			$rootScope.authResolved = true;
	//
	// 		}).catch(function() {
	// 			$rootScope.authResolved = true;
	// 		});
	// 	} else {
	// 		$rootScope.isAuthorized = false;
	// 		$rootScope.authResolved = true;
	// 	}
	//
	// });
	AuthService.getUser().then(function(data) {

		if (data && data.user) {
			// console.log('User resolving user...',data.user);
			$rootScope.setCurrentUser(data.user);
			$rootScope.isAuthorized = true;
		} else {
			// console.log('not data');
			$rootScope.isAuthorized = false;
		}

		$rootScope.authResolved = true;

		$scope.checkUserAuth($state.current.params || {});
	});


	$rootScope.currentUser = null;

	// Le hostess non usano il portale: vengono mandate alla webapp di gestione evento
	$rootScope.isHostess = function (user)
	{
		return !!user && user.role === 'service' && user.sub_role === 'hostess';
	};

	$rootScope.redirectHostess = function (user)
	{
		if ( !$rootScope.isHostess(user) ) {
			return false;
		}

		window.location.href = '/gestione-evento';
		return true;
	};

	$rootScope.setCurrentUser = function (user)
	{
		if ( $rootScope.redirectHostess(user) ) {
			return;
		}

		if ( user ) {
			$rootScope.isAdmin         = user.role === 'admin';
			$rootScope.isService       = user.role === 'service';
			$rootScope.isReportManager = user.role === 'report_manager';
			$rootScope.isAM            = user.role === 'area_manager';
			$rootScope.isZM            = user.role === 'zone_manager';
		}

		$rootScope.currentUser  = user;
		$rootScope.isAuthorized = !!user;
	};

	$scope.$on(AUTH_EVENTS.notAuthenticated, function() {
		userRedirect('notAuthenticated');
	});

	$scope.$on(AUTH_EVENTS.sessionTimeout, function() {
		userRedirect('sessionTimeout');
	});

	$scope.checkUserAuth = function(nextStateParams)
	{
		$rootScope.bodyClass = $state.current.name.replace('.', ' ');
		$rootScope.$state = $state;

		// console.log('checkUserAuth');

		if ( nextStateParams.need_auth ) {
			if ( !$rootScope.isAuthorized && $rootScope.authResolved ) {
				$rootScope.hideLoader();
				$rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
			}
		} else {

			if ( $state.current.name === 'app.auth_login' && $rootScope.isAuthorized ) {
				$state.go('app.dashboard');
			}
		}
	};
	$scope.checkUserAuth( ( $state.current.params ? $state.current.params : {} ) );






	// ============================= //
	//
	// ANGULAR STATES NAVIGATIONS
	//
	// ============================= //

	$rootScope.bodyClass = $state.current.name.replace('.', ' ');
	$rootScope.$state = $state;

	$transitions.onStart({}, function() {
		$rootScope.showLoader();
	});

	$transitions.onFinish({}, function() {
		$rootScope.hideLoader();
		$rootScope.menuOpen = false;
	});

	$transitions.onBefore({}, function(transition) {
		$rootScope.bodyClass = transition.to().name.replace('.', ' ');

		if ( transition.to().params &&
			 transition.to().params.need_auth &&
			$rootScope.authResolved &&
			!$rootScope.isAuthorized )
		{
			window.location.href = '/nam/login';
			return false;

			// return transition.router.stateService.target('app.auth_login');
		}
	});










	// ============================= //
	//
	// UTILITIES
	//
	// ============================= //

	$rootScope.maxUploadSize           = CONFIG.maxUploadSize;
	$rootScope.userCategories          = USER_CATEGORIES;
	$rootScope.userRoles               = USER_ROLES;
	$rootScope.userSubRoles            = USER_SUB_ROLES;

	var rolesLabels = {};

	angular.forEach( $rootScope.userCategories, function(cat) {
		rolesLabels[cat.category] = [];
		angular.forEach( $rootScope.userRoles[cat.category], function(role) {
			rolesLabels[cat.category][role.role] = role.label;
		});
	});
	$rootScope.rolesLabels = rolesLabels;

	$rootScope.documentTypes           = DOC_REGISTRATION_TYPES;
	$rootScope.relationshipTypes       = ACC_RELATIONSHIPS;
	$rootScope.transferTypes           = TRANSFER_TYPES;
	$rootScope.nations                 = getCountries;
	$rootScope.approvationListStatutes = APPROVATION_LIST_STATUS;
	$rootScope.userFields              = USER_FIELDS;

	$rootScope.sexes = [{
		value: 'F', label: 'Femmina'
	},{
		value: 'M', label: 'Maschio'
	}];

	$rootScope.excludePropArray = [
		'birth_place',
		'nationality',
		'address',
		'city',
		'food',
		'notes',
		'doc_type',
		'doc_number',
		'doc_emission_place',
		'doc_emission_date',
		'doc_expiration_date'
	];

	// USER
	$rootScope.userData = {};

	$rootScope.getUser = function(userId, openModal) {
		$scope.showLoader();
		UserListService
			.get(userId)
			.then(function(user) {
				$scope.hideLoader();

				if ( user ) {
					if ( user.parent ) {
						if ( user.parent.role === 'agency' && user.parent.agency_name !== '' && user.parent.agency_name != null ) {
							user.parent.label = user.parent.agency_name;
						} else {
							user.parent.label = user.parent.first_name + ' ' + user.parent.last_name;
						}
					}

					if ( user.props.length === 0 ) {
						user.props = {};
					}

					$rootScope.userData = user;

					$scope.$broadcast('user_loaded', { openModal: openModal });
				}
			});
	};

	function _openUserModal()
	{
		var modalInstance = $uibModal.open({
			animation: true,
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			templateUrl: './templates/modals/user-detail.html',
			controller: 'ModalUserDetailInstanceController',
			controllerAs: '$ctrl',
			size: 'lg',
			windowClass: 'modal-user-detail'
		});

		modalInstance.result.then(function (data) {
		}, function () { });
	}

	$rootScope.viewUserDetail = function(userId) {
		$rootScope.getUser(userId, true);
	};

	$scope.$on('user_loaded', function(event, opt) {
		if ( opt.openModal ) {
			_openUserModal();
		}
	});


	$rootScope.includesValue = function ( container, value ) {
		var returnValue = false;
		var pos = container.indexOf(value);
		if (pos >= 0) {
			returnValue = true;
		}
		return returnValue;
	}


	$rootScope.parseStages = function(data) {
		angular.forEach(data, function(st, key) {
			if ( st ) {
				data[key].from_date = moment.unix( st.from_date ).toDate();
				data[key].from_time = data[key].from_date;
				data[key].to_date   = moment.unix( st.to_date ).toDate();
				data[key].to_time   = data[key].to_date;
				data[key].dp_from   = false;
				data[key].dp_to     = false;
			}
		});

		return data;
	};

	$rootScope.parseServices = function(data) {
		var tmp = [];
		angular.forEach(data, function(sr, key) {
			tmp.push( sr.user_id );
		});
		return tmp;
	};

	$rootScope.parsePartners = function(data) {
		var tmp = [];
		angular.forEach(data, function(sr, key) {
			tmp.push( sr.id );
		});
		return tmp;
	};

	$rootScope.eventTypesLabels = {};
	angular.forEach(EVENT_TYPES, function(et) {
		$rootScope.eventTypesLabels[ et.type ] = et.label;
	});

	$rootScope.taskTypesLabels = {};
	angular.forEach(TASK_TYPES, function(tt) {
		$rootScope.taskTypesLabels[ tt.type ] = tt.label;
	});

	$rootScope.resetEventData = function()
	{
		$rootScope.eventData = {
			title: '',
			description: '',
			type: '',
			multistage: false,
			formative: false,
			sustainable: false,
			fb_url: '',
			tw_url: '',
			ig_url: '',
			yt_url: '',
			sex_field: false,
			birth_place_field: false,
			dob_field: false,
			nationality_field: false,
			address_field: false,
			city_field: false,
			acc_field: false,
			doc_field: false,
			food_field: false,
			transfer_field: false,
			size_field: false,
			notes_field: false,
			cover: '',
			stages: [{
				from_date: '',
				to_date: '',
				location: null,

				// Datepickers
				dp_from: false,
				dp_to: false,
				hostesses: []
			}],
		};
	};

	$rootScope.getEventTags = function(eventId) {
		EventTagListService
			.list(eventId)
			.then( function(data) {
				$rootScope.eventTagData = data;

				$scope.$broadcast('event_tag_loaded');
			});
	};

	$rootScope.getEventFields = function(eventId) {
		EventFieldListService
			.list(eventId)
			.then( function(data) {
				$rootScope.eventFieldData = data;

				$scope.$broadcast('event_field_loaded');
			});
	};

	$rootScope.getEvent = function(eventId) {
		$scope.showLoader();

		EventListService
			.get(eventId)
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {

					data.cover = {
						dataURL: data.cover,
						resized: {
							dataURL: data.thumb
						}
					};

					data.logo = {
						dataURL: data.logo,
						resized: {
							dataURL: data.logo
						}
					};

					if ( data.featured_image ) {
						data.featured_image = {
							dataURL: data.featured_image,
							resized: {
								dataURL: data.featured_image
							}
						};
					}

					if ( data.featured_image_mobile ) {
						data.featured_image_mobile = {
							dataURL: data.featured_image_mobile,
							resized: {
								dataURL: data.featured_image_mobile
							}
						};
					}
					
					data.workshop_open   = (data.workshop_open == 1);

					if ( data.votation_closing_date ) {
						data.votation_closing_date = moment( data.votation_closing_date ).toDate();
					}

					data.stages          = $rootScope.parseStages(data.stages);
					data.services        = $rootScope.parseServices(data.services);
					data.partners        = $rootScope.parsePartners(data.partners);

					$rootScope.eventData = data;

					if ( !$rootScope.year ){
						$rootScope.year = moment(data.stages[0].from_date ).format('YYYY');
					}

					$scope.$broadcast('event_loaded');

				}
			});
	};

	$rootScope.getEventStages = function(eventId) {
		EventListService
			.getStagesList(eventId)
			.then(function(data) {
				$scope.hideLoader();
				if ( data ) {
					$rootScope.stages = $rootScope.parseStages( data );

					$scope.$broadcast('stages_loaded');
				}
			});
	};


	// AGENDA
	$rootScope.agendaData = [];

	$rootScope.parseAgenda = function(data) {

		angular.forEach(data, function(ts, key) {
			data[key].day       = moment( ts.day, 'YYYY-MM-DD' ).format('DD/MM/YYYY');
			data[key].from_time = moment.unix( ts.from_time ).toDate();
			data[key].to_time   = moment.unix( ts.to_time ).toDate();
		});

		return data;
	};

	$rootScope.getAgenda = function(eventId, stageId) {
		$scope.showLoader();
		AgendaService
			.get( eventId, stageId )
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.agendaData = $rootScope.parseAgenda(data);
			});
	};


	// INVITATION
	$rootScope.invitationListData = {
		event_id: null,
		name: '',
		stage_id: null,
		all_stage: true
	};

	$rootScope._prepareInvitationData = function(data, openModal)
	{
		if ( !data ) {
			return;
		}
		$rootScope.invitationData     = data.invitation;
		$rootScope.registrationData   = data.registration_data;
		$rootScope.invitationListData = data.invitation_list;
		$rootScope.eventData          = data.event;
		$rootScope.location           = data.location;
		$rootScope.userData           = data.user;
		$rootScope.preselectionData   = data.preselection_list;

		$scope.same_date = ( $rootScope.eventData.from_date == $rootScope.eventData.to_date ? true : false );

		if ( !$rootScope.registrationData ) {
			$rootScope.registrationData = {};
		}

		if ( data.load_user && $rootScope.registrationData && Object.size( $rootScope.registrationData ) == 0  ) {
			//if ( data.load_user && $rootScope.registrationData && Object.size( $rootScope.registrationData ) == 0 ) {
			var u = angular.copy($rootScope.userData);
			delete u.id;
			delete u.gfv_code;
			delete u.area;
			delete u.zone;
			delete u.role;
			delete u.parent_id;
			delete u.privacy;
			delete u.privacy_date;
			delete u.agency_address;
			delete u.agency_city;
			delete u.agency_code;
			delete u.agency_email;
			delete u.agency_fax;
			delete u.agency_name;
			delete u.agency_net;
			delete u.agency_phone;
			delete u.agency_prov;
			delete u.agency_zip;

			$rootScope.registrationData = Object.assign( data.invitation, u );
		}

		if ( $rootScope.registrationData ) {

			if ( $rootScope.registrationData.dob ) {
				$rootScope.registrationData.dob = moment.unix( $rootScope.registrationData.dob ).toDate();
			}

			if ( $rootScope.registrationData.doc_emission_date ) {
				$rootScope.registrationData.doc_emission_date = moment.unix( $rootScope.registrationData.doc_emission_date ).toDate();
			}

			if ( $rootScope.registrationData.doc_expiration_date ) {
				$rootScope.registrationData.doc_expiration_date = moment.unix( $rootScope.registrationData.doc_expiration_date ).toDate();
			}

			if ( $rootScope.registrationData.acc_dob ) {
				$rootScope.registrationData.acc_dob = moment.unix( $rootScope.registrationData.acc_dob ).toDate();
			}

			if ( $rootScope.registrationData.acc_doc_emission_date ) {
				$rootScope.registrationData.acc_doc_emission_date = moment.unix( $rootScope.registrationData.acc_doc_emission_date ).toDate();
			}

			if ( $rootScope.registrationData.acc_doc_expiration_date ) {
				$rootScope.registrationData.acc_doc_expiration_date = moment.unix( $rootScope.registrationData.acc_doc_expiration_date ).toDate();
			}

			if ( $rootScope.registrationData.data_partenza ) {
				$rootScope.registrationData.data_partenza = moment.unix( $rootScope.registrationData.data_partenza ).toDate();
			}

			if ( $rootScope.registrationData.ora_partenza_andata ) {
				$rootScope.registrationData.ora_partenza_andata = moment.unix( $rootScope.registrationData.ora_partenza_andata ).toDate();
			}

			if ( $rootScope.registrationData.ora_arrivo_andata ) {
				$rootScope.registrationData.ora_arrivo_andata = moment.unix( $rootScope.registrationData.ora_arrivo_andata ).toDate();
			}

			if ( $rootScope.registrationData.data_ritorno ) {
				$rootScope.registrationData.data_ritorno = moment.unix( $rootScope.registrationData.data_ritorno ).toDate();
			}

			if ( $rootScope.registrationData.ora_partenza_ritorno ) {
				$rootScope.registrationData.ora_partenza_ritorno = moment.unix( $rootScope.registrationData.ora_partenza_ritorno ).toDate();
			}

			if ( $rootScope.registrationData.ora_arrivo_ritorno ) {
				$rootScope.registrationData.ora_arrivo_ritorno = moment.unix( $rootScope.registrationData.ora_arrivo_ritorno ).toDate();
			}

			if ( $rootScope.userData.avatar && $rootScope.eventData.avatar_field ) {
				$rootScope.registrationData.avatar = $rootScope.userData.avatar;
			}

			if ( $rootScope.registrationData.mobile ) {
				$rootScope.registrationData.mobile = $rootScope.registrationData.mobile.replace(/[^0-9]/g,'');
				if ( $rootScope.registrationData.mobile.length < 9 ) {
					$rootScope.registrationData.mobile = '';
				}
			}
		}


		if ( !openModal ) {
			openModal = false;
		}

		$scope.$broadcast('invitation_loaded', { openModal: openModal });
	};


	$rootScope.getInvitationsLists = function( eventId ) {
		$scope.showLoader();

		InvitationListListService
			.fullList( eventId )
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {
					$rootScope.invitationsLists = data;
				} else {
					$rootScope.manageError(data);
				}
			});
	};


	$rootScope.getInvitationList = function(invitationListId) {
		$scope.showLoader();

		InvitationListListService
			.get( invitationListId )
			.then(function(data) {
				$scope.hideLoader();

				data.dem = {
					dataURL: data.dem,
					resized: {
						dataURL: data.dem
					}
				};

				data.dem_logo = {
					dataURL: data.dem_logo,
					resized: {
						dataURL: data.dem_logo
					}
				};

				data.dem_confirm = {
					dataURL: data.dem_confirm,
					resized: {
						dataURL: data.dem_confirm
					}
				};

				data.dem_confirm_logo = {
					dataURL: data.dem_confirm_logo,
					resized: {
						dataURL: data.dem_confirm_logo
					}
				};

				data.badge = {
					dataURL: data.badge,
					resized: {
						dataURL: data.badge
					}
				};

				data.badge_logo = {
					dataURL: data.badge_logo,
					resized: {
						dataURL: data.badge_logo
					}
				};

				data.zm_expiration_date = moment.unix( data.zm_expiration_date ).toDate();
				data.zm_expiration_time = data.zm_expiration_date;
				data.am_expiration_date = moment.unix( data.am_expiration_date ).toDate();
				data.am_expiration_time = data.am_expiration_date;

				$rootScope.invitationListData = data;

				$rootScope.invitationListData.program = '';

				$rootScope.invitationListData.all_stage = ( $rootScope.invitationListData.all_stage ? true : false );

				if ( !$rootScope.invitationListData.all_stage ) {
					var fromDate = moment.unix($rootScope.invitationListData.stage.from_date ).format('DD/MM/YYYY'),
						toDate   = moment.unix($rootScope.invitationListData.stage.to_date ).format('DD/MM/YYYY');

					if ( fromDate === toDate ) {
						$rootScope.invitationListData.stage.same_date = true;
					}
				}

				$rootScope.getEvent( $rootScope.invitationListData.event_id );

				$rootScope.getEventStages( $rootScope.invitationListData.event_id );

				$scope.$broadcast('invitation_list_loaded');

			});
	};

	$rootScope.getInvitationsByEvent = function(eventId) {
		$scope.showLoader();

		InvitationListService
			.listByEvent(eventId)
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.invitations = data;
			});
	};

	$rootScope.getInvitationsByEventNoRooms = function(eventId) {
		$scope.showLoader();

		InvitationListService
			.listByEventNoRooms(eventId)
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.invitations = data;

				$scope.$broadcast('invitation_list_loaded');
			});
	};

	$rootScope.getInvitationsByEventNoTransfers = function(eventId) {
		$scope.showLoader();

		InvitationListService
			.listByEventNoTransfers(eventId)
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.invitations = data;
			});
	};


	$rootScope.getInvitationByHash = function(hash)
	{
		$scope.showLoader();

		InvitationListService
			.getByHash(hash)
			.then(function(data) {
				$scope.hideLoader();

				$rootScope._prepareInvitationData(data);
				$scope.$broadcast('invitation_loaded');
			});
	};


	$rootScope.getInvitationById = function( id , openModal )
	{
		$scope.showLoader();

		if ( !openModal ) {
			openModal = false;
		}

		InvitationListService
			.get(id)
			.then(function(data) {
				$scope.hideLoader();

				$rootScope._prepareInvitationData(data, openModal);
			});
	};


	// APPROVATION LIST
	$rootScope.approvationListData = {};

	$rootScope.getApprovationList = function(approvationListId) {
		$scope.showLoader();
		ApprovationListListService
			.get( approvationListId )
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.approvationListData = data;

				$scope.$broadcast('approvation_list_loaded');
			});
	};


	// MEDIA DIRECTORY
	$rootScope.mediaDirectoryData = {};
	$rootScope.getMediaDirectory = function(mediaDirectoryId) {
		$scope.showLoader();

		MediaDirectoryListService
			.get(mediaDirectoryId)
			.then(function(data) {
				$scope.hideLoader();
				$rootScope.mediaDirectoryData = data;
			});
	};


	// MATERIAL
	$rootScope.materialData = {};
	$rootScope.getMaterial = function(materialId) {
		$scope.showLoader();


		MaterialListService
			.get(materialId)
			.then(function(data) {
				$scope.hideLoader();
		console.log( data );
				$rootScope.materialData = data;
			});
	};


	// SURVEY
	$rootScope.surveyData = {};
	$rootScope.getSurvey = function(surveyId) {
		$scope.showLoader();

		SurveyListService
			.get(surveyId)
			.then(function(data) {
				$scope.hideLoader();
				$rootScope.surveyData = data;
			});
	};


	// MEDIA DIRECTORY
	$rootScope.feedbackCategoryData = {};
	$rootScope.getFeedbackCategory = function(categoryId) {
		$scope.showLoader();

		FeedbackCategoryListService
			.get(categoryId)
			.then(function(data) {
				$scope.hideLoader();
				$rootScope.feedbackCategoryData = data;
			});
	};

	// RELATOR
	$rootScope.relatorData = {};
	$rootScope.getRelatorList = function() {
		$scope.showLoader();

		RelatorListService
			.fullList()
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.relatorList = data;
			});
	};

	$rootScope.getRelator = function(relatorId) {
		$scope.showLoader();

		RelatorListService
			.get(relatorId)
			.then(function(data) {
				$scope.hideLoader();

				data.avatar = {
					dataURL: data.avatar,
					resized: {
						dataURL: data.avatar
					}
				};

				$rootScope.relatorData = data;
			});
	};

	$rootScope.partnerData = {};
	$rootScope.getPartnerList = function() {
		$scope.showLoader();

		PartnerListService
			.fullList()
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.partnerList = data;
			});
	};
	$rootScope.getPartner = function(partnerId) {
		$scope.showLoader();

		PartnerListService
			.get(partnerId)
			.then(function(data) {
				$scope.hideLoader();

				data.avatar = {
					dataURL: data.avatar,
					resized: {
						dataURL: data.avatar
					}
				};

				$rootScope.partnerData = data;
			});
	};


	// WIKI
	$rootScope.wikiData = {};
	$rootScope.getWikiList = function() {
		$scope.showLoader();

		WikiListService
			.fullList()
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.wikiList = data;
			});
	};

	$rootScope.getWiki = function(wikiId) {
		$scope.showLoader();

		WikiListService
			.get(wikiId)
			.then(function(data) {
				$scope.hideLoader();

				data.image = {
					dataURL: data.image,
					resized: {
						dataURL: data.image
					}
				};

				data.introduction_date = moment(data.introduction_date).toDate();

				$rootScope.wikiData = data;
			});
	};


	// WORKSHOP
	$rootScope.workshopData = {};
	$rootScope.workshopSessionData = {};

	$rootScope.parseWorkshopSession = function(data) {
		angular.forEach(data, function(sess, key) {
			data[key].from_date = moment.unix( sess.from_time ).toDate();
			data[key].from_time = moment.unix( sess.from_time ).toDate();
			data[key].to_date   = moment.unix( sess.to_time ).toDate();
			data[key].to_time   = moment.unix( sess.to_time ).toDate();
		});
		return data;
	};


	$rootScope.getWorkshop = function(workshopId)
	{
		$scope.showLoader();

		WorkshopListService
			.get(workshopId)
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.workshopData = data;
				
				$scope.$broadcast('workshopData_loaded');

			});
	};


	$rootScope.getWorkshopList = function(eventId) {
		$scope.showLoader();

		WorkshopListService
			.fullList(eventId)
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.workshopList = data;
			});
	};


	$rootScope.getWorkshopSession = function(workshopSessionId) {
		$scope.showLoader();

		WorkshopSessionListService
			.get(workshopSessionId)
			.then(function(data) {
				$scope.hideLoader();

				data.from_date = moment.unix( data.from_time ).toDate();
				data.from_time = moment.unix( data.from_time ).toDate();
				data.to_date   = moment.unix( data.to_time ).toDate();
				data.to_time   = moment.unix( data.to_time ).toDate();

				data.day       = moment( data.from_time ).format('DD/MM/YYYY');

				$rootScope.workshopSessionData = data;
				
				$scope.$broadcast('workshopSessionData_loaded');
			});
	};

	$rootScope.getWorkshopSessionByEvent = function(eventId) {
		$scope.showLoader();

		WorkshopSessionListService
			.listByEvent(eventId)
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.workshopSessionList = $rootScope.parseWorkshopSession( data );
			});
	};

	$rootScope.getTrackList = function(eventId) {
		$scope.showLoader();

		TrackListService
			.fullList(eventId)
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.trackList = data;
			});
	};


	// HOTELS
	$rootScope.getHotelList = function() {
		$scope.showLoader();

		HotelListService
			.fullList()
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.hotelList = data;

				$scope.$broadcast('hotel_list_loaded');
			});
	};


	// ROOM
	$rootScope.roomOccupations = {};
	$rootScope.roomData = {};

	angular.forEach(ROOM_OCCUPATIONS, function(rt) {
		$rootScope.roomOccupations[ rt.occupation ] = rt.label;
	});

	$rootScope.getRoom = function(roomId) {
		$scope.showLoader();

		RoomListService
			.get(roomId)
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.roomData = data;
			});
	};

	$rootScope.getRoomList = function(eventId, roomId) {
		$scope.showLoader();

		RoomListService
			.fullList(eventId, roomId)
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.roomList = data;

				$scope.$broadcast('room_list_loaded');
			});
	};

	$rootScope.getInvitationRoom = function(invitationRoomId) {
		$scope.showLoader();

		InvitationRoomListService
			.get(invitationRoomId)
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.invitationRoomData = data;

				$scope.$broadcast('invitation_room_loaded');
			});
	};


	// TRANSFER
	$rootScope.parseInvitationTransfers = function(data) {
		angular.forEach(data, function(tr, key) {
			data[key].pick_up_date = moment.unix( tr.pick_up_date ).toDate();
		});
		return data;
	};

	$rootScope.getTransferList = function(eventId) {
		$scope.showLoader();

		TransferListService
			.fullList(eventId)
			.then(function(data) {
				$scope.hideLoader();
				$rootScope.transferList = data;
			});
	};

	$rootScope.getInvitationTransfer = function(invitationTransferId) {
		$scope.showLoader();

		InvitationTransferListService
			.get(invitationTransferId)
			.then(function(data) {
				$scope.hideLoader();

				data.pick_up_date = moment.unix( data.pick_up_date ).toDate();
				data.pick_up_time = data.pick_up_date;

				$rootScope.invitationTransferData = data;
			});
	};


	$rootScope.servicesUsers = {};

	$rootScope.getServicesUsers = function()
	{
		UserListService
			.listByRole('service', 'service')
			.then(function (data) {

				var tmpServices = [];

				angular.forEach(data, function (user) {
					tmpServices.push({
						id: user.id,
						label: user.first_name + ' ' + user.last_name
					});
				});

				UserListService
					.listByRole('admin', 'admin')
					.then(function (data) {

						angular.forEach(data, function (user) {
							tmpServices.push({
								id: user.id,
								label: user.first_name + ' ' + user.last_name
							});
						});

						$rootScope.servicesUsers = tmpServices;

					});
			});
	};





})

.controller('ModalUserDetailInstanceController', function ($scope, $uibModalInstance) {

	$scope.closeModal = function () {
		$uibModalInstance.dismiss('cancel');
	};

});

